import React, { useContext, useEffect, useRef, useState } from 'react';
import LinkMediaVideoHeader from './LinkMediaVideoHeader';
import GallerySection from './GallerySection';
import PreviewHeader from './PreviewHeader';
import VideoController from './VideoController';
import PlayAllButton from './PlayAllButton';
 
import AudioPlayer from './AudioPlayer';
import { Context } from "../contexts/AppContext";
import { useParams } from 'react-router-dom';

const LinkMedia = React.memo(() => {

  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const { galleryId } = useParams();

  //console.log("Gallery ID:", galleryId); // Output: 67e629da4130bb2ab70deeec
  //console.log("LINK MEDIA CALL------")
  const iframeRef = useRef(null);
  const [device, setDevice] = useState('desktop'); // default view

  // Dynamic sizes based on selected device
  const deviceStyles = {
    mobile: { width: '375px', height: 'calc(100vh - 180px)' },
    tablet: { width: '768px', height: 'calc(100vh - 180px)' },
    desktop: { width: '1000px', height: 'calc(100vh - 180px)' },
  };

  const linkStyle = {
    position: 'relative',
    width: deviceStyles[device].width,
    height: deviceStyles[device].height,
    minHeight: '520px',
    maxHeight: '613px',
    maxWidth: '100%',
    margin: 'auto',
  
    boxSizing: 'border-box',
    borderRadius: '15px',
    background: '#1a1a1a',
    border: '1px solid #161616',
    transition: 'all 0.3s ease-in-out',
  };

  const iframeStyle = {
    top: '0px',
    left: '16px',
    right: '16px',
    bottom: '0px',
    height: '100%',
    
  };

  useEffect(()=>{
   

    if (iframeRef.current) {
      console.log("POSTTTTTTTTTTT MESSAGE---------")
      iframeRef.current.contentWindow.postMessage(appState, "*");
    }
  },[appState?.currentGalleryData?.setting, appState.currentGalleryVideoTitle, appState.currentGalleryVideoSubTitle, appState.currentFontFamilyVideoTitle, appState.currentFontFamilyVideoSubTitle,appState.currentGalleryData?.backgroundMedia,appState?.currentGalleryData?.selectedVideos, appState.selectedVideos])
  
  
  return (
    <div
    id="rrrrrr"
      style={{
        flex: '1 1 calc(100% - 280px)',
        borderLeft: '1px solid lightgray',
        padding: '10px',
      }}
    > 
      {/* Passing setDevice to PreviewHeader */}
      <PreviewHeader setDevice={setDevice} />
      
      <div style={{ padding: '15px 10px', position:'relative'}}>
        <div style={linkStyle}>
          {/* Browser-like circles */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              opacity: '0.4',
              position: 'absolute',
              top: '2px',
              left: '12px',
              padding:'2px'
            }}
          >
            <Circle color="#ff605c" />
            <Circle color="#ffbd44" />
            <Circle color="#00ca4e" />
          </div>

          {/* Preview Content */}
          <div id="222222222222" style={iframeStyle}> 
         
          <iframe
      title="Child App"
      id="iframeCont"
      src={`${process.env.REACT_APP_TO_CLIENT}${galleryId}`} // Dynamic src
      width="98%"
      height="94%"
      ref={iframeRef}
     
       
      style={{ display:"flex",   margin:"2% auto", border:"1px solid", borderRadius:"15px" }}
      
    />
             
          </div>
        </div>
      </div>


    </div>
  );
});

// Circle Button
const Circle = ({ color }) => {
  return (
    <div
      className="w-2.5 h-2.5 rounded-full mr-1.5"
      style={{ backgroundColor: color }}
    />
  );
};

export default LinkMedia;
